import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Collapse,
  Stack,
  Divider,
  Menu,
  Checkbox,
  Slider,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import { AIModelSelect } from "./TestComponents2";
import { useSnackbar } from "./SnackbarHandler";
import AddIcon from "@mui/icons-material/Add";
import { BackButton, mapLanguageToEnglish } from "./functions";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { AnimatedStep } from "./Animations";
import { formatDate, availableSpeakers } from "./functions";
import Quill from "./Quill";
import ShareLink from "./ShareLink";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Popper } from "@mui/material";
import LanguageSelector from "./LanguageSelector";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import Dialog from "@mui/material/Dialog";
import { useNavigate } from "react-router-dom";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";
import CloseIcon from "@mui/icons-material/Close";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import GenerateIcon from "@mui/icons-material/AutoAwesome";
import SlideInPaper from "./SlideInPaper";
import TeacherSearch from "./TeacherSearch";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageLoadingDialog from "./ImageLoadingDialog";
import PrintAsPdf from "./PrintAsPdf";

import AssignmentIcon from "@mui/icons-material/Assignment";
import SettingsIcon from "@mui/icons-material/Settings";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Translate from "./Translate";
import {
  collection,
  query,
  where,
  limit,
  addDoc,
  updateDoc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";

import InfoBox from "./InfoBox";

import { ThemeSelectorFlow } from "./ThemeSelectorFlow";

import { useTheme } from "@mui/material/styles";
import { getStyles } from "../index";
import { trackLesson, handleImageGenerationError } from "./functions";
import Logger from "./Logger";

const PodcastGenerator = ({ user, isDark }) => {
  const [inputType, setInputType] = useState("url");
  const [urls, setUrls] = useState("");
  //const [topic, setTopic] = useState("August Strindberg");
  const [loading, setLoading] = useState(false);
  const [isLongForm, setIsLongForm] = useState(false);
  const [audioUrl, setAudioUrl] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [selectedModel, setSelectedModel] = useState("Studera.AI");
  const [currentStep, setCurrentStep] = useState(0);
  const [podcastType, setPodcastType] = useState("");
  const [languageMenuAnchorEl, setLanguageMenuAnchorEl] = useState(null);

  const [podcastNameOwn, setPodcastNameOwn] = useState("");
  const { showSnackbar } = useSnackbar();

  const [customTheme, setCustomTheme] = useState("");
  const [lessonTheme, setLessonTheme] = useState("");
  const [predefinedTheme, setPredefinedTheme] = useState(null);
  const navigate = useNavigate();
  const [speaker1, setSpeaker1] = useState("");
  const [speaker2, setSpeaker2] = useState("");
  const [openSpeakerDialog, setOpenSpeakerDialog] = useState(false);
  const [currentSpeakerSelection, setCurrentSpeakerSelection] = useState(null); // 1 or 2

  const transcriptRef = useRef("");

  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const uploadedFileRef = useRef("");

  const wikipediaContentRef = useRef("");
  const randomizedContentRef = useRef("");
  const coursePlanContentRef = useRef("");

  const urlContentRef = useRef("");
  const bookContentRef = useRef("");

  const analysisContentRef = useRef("");
  const pasteTextContentRef = useRef("");
  const resetThemeContent = () => {
    setLessonTheme("");
    setCustomTheme("");
    setPredefinedTheme(null);
    transcriptRef.current = "";
    uploadedFileRef.current = "";
    wikipediaContentRef.current = "";
    randomizedContentRef.current = "";
    bookContentRef.current = "";
    urlContentRef.current = "";
    analysisContentRef.current = "";
    coursePlanContentRef.current = "";
    pasteTextContentRef.current = "";
  };

  useEffect(() => {
    Logger.log("speaker1: ", speaker1);
    Logger.log("speaker2: ", speaker2);
    if (currentStep === 2 && speaker1 && speaker2) {
      setCurrentStep(3);
    }
  }, [podcastType, currentStep, speaker1, speaker2]);

  const theme = useTheme();
  const styles = getStyles(theme);

  // New customization states
  const [showCustomizations, setShowCustomizations] = useState(false);
  const [conversationStyle, setConversationStyle] = useState([
    "Utbildande",
    "Avslappnad",
    "Snabbt tempo",
  ]);
  const [rolePerson1, setRolePerson1] = useState("Programledare");
  const [rolePerson2, setRolePerson2] = useState("Gäst");
  const [podcastName, setPodcastName] = useState("Studera.AI");
  const [podcastTagline, setPodcastTagline] = useState(
    "där du kan generera podcasts baserat på vilket innehåll du vill.",
  );
  const [outputLanguage, setOutputLanguage] = useState("svenska");
  const [userInstructions, setUserInstructions] = useState("");

  const [engagementTechniques, setEngagementTechniques] = useState([
    "Retoriska frågor",
  ]);
  const [creativity, setCreativity] = useState(0.5);
  const [ttsModel, setTtsModel] = useState("openai");
  const [dialogueStructure, setDialogueStructure] = useState([
    "Introduktion av ämnet",
    "Diskussioner",
    "Avslutande ord",
  ]);

  const styleOptions = [
    "Engagerande",
    "Snabbt tempo",
    "Entusiastisk",
    "Utbildande",
    "Lugn",

    "Avslappnad",
    "Humoristisk",

    "Formell",
    "Analytisk",
    "Kritisk",
  ];

  const engagementOptions = [
    "Retoriska frågor",
    "Personliga berättelser",
    "Citat",
    "Anekdoter",
    "Liknelser",
    "Humor",

    "Sokratisk frågeställning",
    "Historiska referenser",
    "Tankexperiment",
  ];

  const structureOptions = [
    "Introduktion av ämnet",
    "Sammanfattning av nyckelpunkter",
    "Diskussioner",
    "Frågor och svar",
    "Avslutande ord",

    "Inledande uttalanden",
    "Presentation av tes",
    "Motargument",
    "Bemötande av motargument",
    "Avslutande kommentarer",
  ];

  // Lägg till denna useEffect för att ändra konfiguration automatiskt när podcastType ändras
  useEffect(() => {
    if (podcastType === "Argumentation/Debatt") {
      setCreativity(0);
      setUserInstructions(
        "Detta ska vara en debatt där ena rollen är tydligt för och den andra rollen är tydligt mot.",
      );
      setRolePerson1("Proponent");
      setRolePerson2("Opponent");
      setConversationStyle(["Formell", "Analytisk", "Kritisk"]);
      setEngagementTechniques([
        "Sokratisk frågeställning",
        "Historiska referenser",
        "Tankexperiment",
      ]);
      setDialogueStructure([
        "Inledande uttalanden",
        "Presentation av tes",
        "Motargument",
        "Bemötande av motargument",
        "Avslutande kommentarer",
      ]);
    } else {
      setRolePerson1("Programledare");
      setRolePerson2("Gäst");
      setConversationStyle(["Utbildande", "Snabbt tempo", "Engagerande"]);
      setEngagementTechniques(["Retoriska frågor"]);
      setDialogueStructure([
        "Introduktion av ämnet",
        "Diskussioner",
        "Avslutande ord",
      ]);
    }
  }, [podcastType]);

  useEffect(() => {
    setUserInstructions(
      `ANVÄND ENDAST ${outputLanguage}. INGA UNDANTAG. ALL TEXT MÅSTE VARA PÅ ${outputLanguage}.`,
    );
  }, [outputLanguage]);

  const ttsOptions = ["openai", "geminimulti", "elevenlabs"];

  const checkContentSize = (content) => {
    if (!content) return 0;
    const bytes = new TextEncoder().encode(content).length;
    return bytes;
  };

  // Update the handleSubmit function in your PodcastGenerator component
  // The handleSubmit function for your frontend
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!podcastNameOwn.trim()) {
      showSnackbar("Skriv in podcastens namn", "warning");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");
    setAudioUrl("");

    try {
      // Prepare the request data
      const requestData = {
        options: {
          longform: isLongForm,
        },
        conversation_config: {
          conversation_style: conversationStyle,
          roles_person1: rolePerson1,
          roles_person2: rolePerson2,
          dialogue_structure: dialogueStructure,
          podcast_name: podcastName,
          podcast_tagline: podcastTagline,
          output_language: mapLanguageToEnglish(outputLanguage),
          user_instructions: userInstructions,
          engagement_techniques: engagementTechniques,
          creativity: creativity,
          text_to_speech: {
            default_tts_model: "openai",
            openai: {
              model: "gpt-4o-mini-tts",
              default_voices: {
                question: speaker1 || "ash",
                answer: speaker2 || "shimmer",
              },
            },
          },
        },
        tts_model: "openai",
        userId: user.uid,
        speaker1: speaker1,
        speaker2: speaker2,
        podcastName: podcastNameOwn,
      };

      let content = "";

      if (lessonTheme === "youtube") {
        content = transcriptRef.current;
      } else if (lessonTheme === "customTheme") {
        content = customTheme;
      } else if (lessonTheme === "predefined") {
        content = predefinedTheme;
      } else if (lessonTheme === "fileUpload") {
        content = uploadedFileRef.current;
      } else if (lessonTheme === "wikipedia") {
        content = wikipediaContentRef.current;
      } else if (lessonTheme === "randomizer") {
        content = randomizedContentRef.current;
      } else if (lessonTheme === "book") {
        content = bookContentRef.current;
      } else if (lessonTheme === "url") {
        content = urlContentRef.current;
      } else if (lessonTheme === "vision") {
        content = analysisContentRef.current;
      } else if (lessonTheme === "pasteText") {
        content = pasteTextContentRef.current;
      } else {
        content = coursePlanContentRef.current;
      }

      Logger.log("themeToUse: ", content);

      const contentSize = checkContentSize(content);
      if (contentSize > 1048487) {
        const sizeMB = (contentSize / (1024 * 1024)).toFixed(2);
        showSnackbar(
          `Underlaget är för stort. Minska textmängden eller bli Premium-användare.`,
          "info",
        );
        return;
      }

      requestData.topic = content;

      Logger.log("Sending request:", requestData);

      const API_URL =
        process.env.NODE_ENV === "production"
          ? "/api"
          : "http://localhost:3001/api";

      // Send initial request to start podcast generation
      const response = await axios.post(
        `${API_URL}/generate-podcast`,
        requestData,
      );

      if (response.data.success) {
        await trackLesson(user.uid, "Podcast.js", null, {
          content: content,
        });

        // Start polling for job status
        pollPodcastStatus(response.data.jobId);
      } else {
        setError("Failed to start podcast generation");
        setLoading(false);
      }
    } catch (err) {
      const API_URL =
        process.env.NODE_ENV === "production"
          ? "/api"
          : "http://localhost:3001/api";

      console.error("Error type:", err.name);
      console.error("Error message:", err.message);

      // Detailed error logging
      let errorDetails = {
        errorType: err.name,
        errorMessage: err.message,
        serverResponse: null,
        requestDetails: null,
        fullError: JSON.stringify(err, Object.getOwnPropertyNames(err)),
      };

      if (err.response) {
        console.error("Server response data:", err.response.data);
        console.error("Server response status:", err.response.status);
        console.error("Server response headers:", err.response.headers);
        errorDetails.serverResponse = {
          data: err.response.data,
          status: err.response.status,
          headers: err.response.headers,
        };
      } else if (err.request) {
        console.error(
          "No response received from server. Request details:",
          err.request,
        );
        errorDetails.requestDetails = err.request;
      }

      console.error("Full error:", err);

      // Send error notification email to admin
      try {
        fetch(`${API_URL}/send-email`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: "Podcast Generator Error",
            email: "system@studera.ai",
            message: `
            Error in Podcast Generator:
            User ID: ${user?.uid || "Unknown"}
            Time: ${new Date().toISOString()}
            Podcast Name: ${podcastNameOwn}

            Error Details:
            Type: ${err.name}
            Message: ${err.message}
            ${err.response ? `Server Response: ${JSON.stringify(err.response.data)}` : ""}
            ${err.response ? `Status Code: ${err.response.status}` : ""}

            Technical Details:
            ${JSON.stringify(errorDetails, null, 2)}
        `,
          }),
        }).catch((emailError) => {
          console.error("Failed to send error notification email:", emailError);
        });
      } catch (emailError) {
        console.error("Failed to send error notification email:", emailError);
      }

      setError(
        `Knak i fogarna: ${err.message} — ${err.response?.data?.error || "Unknown error"} - Vänligen skicka felmeddelandet till info@studera.ai så fixar vi det så fort som möjligt.`,
      );
      setLoading(false);
    }
  };

  // The polling function for your frontend
  const pollPodcastStatus = async (jobId) => {
    const API_URL =
      process.env.NODE_ENV === "production"
        ? "/api"
        : "http://localhost:3001/api";

    try {
      // Keep track of when we started polling
      const startTime = Date.now();

      // Set up polling interval (check every 10 seconds)
      const intervalId = setInterval(async () => {
        try {
          console.log(`Polling job status for jobId: ${jobId}`);
          const statusResponse = await axios.get(
            `${API_URL}/podcast-status/${jobId}`,
          );

          if (statusResponse.data.success) {
            const { status, podcastId, error, podcastUrl } =
              statusResponse.data;
            console.log(`Job status: ${status}, podcastId: ${podcastId}`);

            if (status === "completed" && podcastId) {
              // Podcast is ready, navigate to it
              clearInterval(intervalId);
              setLoading(false);
              setSuccess("Podcast generated successfully!");
              if (podcastUrl) {
                setAudioUrl(podcastUrl);
              }
              navigate(`/app/podcast/${podcastId}`);
            } else if (status === "failed") {
              // Handle failure
              clearInterval(intervalId);
              setLoading(false);
              setError(error || "Failed to generate podcast");
            }
            // If still processing, continue polling
          } else {
            // Handle API error
            clearInterval(intervalId);
            setLoading(false);
            setError("Failed to check podcast status");
          }
        } catch (pollError) {
          console.error("Error polling podcast status:", pollError);
          // Don't stop polling on individual request errors,
          // unless it's been more than 10 minutes (600000ms) since we started
          if (Date.now() - startTime > 600000) {
            clearInterval(intervalId);
            setLoading(false);
            setError("Podcast generation timed out. Please try again later.");
          }
        }
      }, 10000); // Check every 10 seconds

      // Set a timeout to stop polling after 10 minutes to prevent indefinite polling
      setTimeout(() => {
        clearInterval(intervalId);
        // Only update state if we're still loading (otherwise we already navigated away)
        if (loading) {
          setLoading(false);
          setError("Podcast generation timed out. Please try again later.");
        }
      }, 600000); // 10 minutes
    } catch (error) {
      console.error("Error setting up polling:", error);
      setLoading(false);
      setError("Failed to set up status checking");
    }
  };

  // Update the ImageLoadingDialog component to show appropriate message
  // In your ImageLoadingDialog component, make sure the message is clear:
  /*
<Typography variant="body1" sx={{ mb: 2 }}>
  {podcast 
    ? "Genererar din podcast i bakgrunden. Du kommer att omdirigeras automatiskt när den är klar."
    : message}
</Typography>
*/

  const getSpeakerAvatar = (speakerId) => {
    const speaker = availableSpeakers.find(
      (speaker) => speaker.id === speakerId,
    );
    return speaker ? speaker.avatar : null;
  };

  // Handle multi-select changes
  const handleStyleChange = (e) => {
    const selected = Array.from(
      e.target.selectedOptions,
      (option) => option.value,
    );
    setConversationStyle(selected);
  };

  const handleEngagementChange = (e) => {
    const selected = Array.from(
      e.target.selectedOptions,
      (option) => option.value,
    );
    setEngagementTechniques(selected);
  };

  const handleStructureChange = (e) => {
    const selected = Array.from(
      e.target.selectedOptions,
      (option) => option.value,
    );
    setDialogueStructure(selected);
  };

  const SpeakerSelectionDialog = () => {
    return (
      <Dialog
        open={openSpeakerDialog}
        onClose={() => setOpenSpeakerDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: "1.4rem" }}>
          Välj en röst
          <IconButton
            aria-label="close"
            onClick={() => setOpenSpeakerDialog(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="subtitle1" sx={{ color: "text.secondary" }}>
            Välj en röst för talaren
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2}>
            {availableSpeakers.map((speaker) => (
              <Grid item xs={6} sm={4} md={3} key={speaker.id}>
                <Paper
                  elevation={3}
                  sx={{
                    ...styles.freshBox,
                    ...styles.softBoxShadow,
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      border: `1px solid ${theme.palette.primary.main}`,
                    },
                  }}
                  onClick={() => {
                    if (currentSpeakerSelection === 1) {
                      setSpeaker1(speaker.id);
                    } else {
                      setSpeaker2(speaker.id);
                    }
                    setOpenSpeakerDialog(false);
                  }}
                >
                  <Avatar
                    src={speaker.avatar}
                    alt={speaker.name}
                    sx={{ width: 90, height: 90 }}
                  />
                </Paper>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          ...styles.innerContainer,
          width: { xs: "100%", md: "100%" },
          margin: "0 auto",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            ...styles.header,
            borderBottom: "0px",
            mb: 4,
            textAlign: "center",
          }}
        >
          Podcast
        </Typography>

        <InfoBox
          instructions={[
            "Välj underlag till ditt quiz, eller skriv in manuella instruktioner",
            "Välj att generera frågor, redigera & anpassa, dela med elever, spara eller skriv ut",
            "Se din historik över resultat, senaste träningstillfället och mycket mer",
          ]}
          theme={theme}
          styles={styles}
          user={user}
          podcast={true}
        />

        {currentStep === 0 && (
          <Grid container spacing={4} sx={{ mt: 0 }}>
            <Grid item xs={12} md={6}>
              <Box
                onClick={() => setCurrentStep(1)}
                sx={{
                  ...styles.freshBox,
                  backgroundColor: "#805ff41a",
                  boxShadow: "none",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "16px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  height: "290px",
                  "&:hover": {
                    backgroundColor: "#805ff429",
                  },
                  "&:hover .plusIcon": {
                    transform: "rotate(90deg)",
                  },
                }}
              >
                <IconButton
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: "#fff",
                    width: "64px",
                    height: "64px",
                    mb: 2,
                    transition: "transform 0.3s ease",
                  }}
                  className="plusIcon"
                >
                  <AddIcon sx={{ fontSize: 32 }} />
                </IconButton>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Skapa ny podcast
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                //   onClick={() => navigate("/app/podcast/6GKhkJl3EqvqfgC4Vr90")}

                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  setLanguageMenuAnchorEl(event.currentTarget);
                }}
                sx={{
                  ...styles.freshBox,
                  cursor: "pointer",
                  boxShadow: "none",
                  height: "290px",
                  ".iconTransition": {
                    transition: "transform 0.3s ease",
                  },
                  transition: "transform 0.3s ease, background-color 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#bebebe1a",
                  },
                  "&:hover .avatarTransition": {
                    transform: "scale(1.05)",
                  },
                  "&:hover .iconTransition": {
                    transform: "translateX(4px)",
                  },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    textAlign: "center",
                    mt: 2,
                  }}
                  noWrap
                >
                  Lyssna på ett exempel
                </Typography>

                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "text.secondary",
                    textAlign: "center",
                    mb: 4,
                    fontSize: "0.9rem",
                  }}
                >
                  Podd om jämställdhetens historia
                </Typography>
                <Box
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <Avatar
                      src={getSpeakerAvatar("nova")}
                      alt="Speaker 1"
                      sx={{
                        width: 100,
                        height: 100,
                        transition: "transform 0.3s ease",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                      }}
                      className="avatarTransition"
                    />
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, fontSize: "1rem" }}
                    >
                      &
                    </Typography>
                    <Avatar
                      src={getSpeakerAvatar("ash")}
                      alt="Speaker 2"
                      sx={{
                        width: 100,
                        height: 100,
                        transition: "transform 0.3s ease",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                      }}
                      className="avatarTransition"
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    mt: 2,
                    display: "none",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,

                      fontSize: "0.9rem",
                    }}
                  >
                    Lyssna
                  </Typography>
                  <NavigateNextIcon className="iconTransition" />
                </Box>
              </Box>
            </Grid>
          </Grid>
        )}
        {currentStep === 1 && (
          <ThemeSelectorFlow
            value={lessonTheme}
            onChange={(e) => setLessonTheme(e.target.value)}
            customTheme={customTheme}
            onCustomThemeChange={(e) => {
              Logger.log("onCustomThemeChange", e.target.value);
              setCustomTheme(e.target.value);
              setCurrentStep(2);
            }}
            onPastedTextChange={(content) => {
              Logger.log("onPastedTextChange", content.target.value);
              pasteTextContentRef.current = content.target.value;
              setCurrentStep(2);
            }}
            onAnalysisContentChange={(content) => {
              Logger.log("onAnalysisContentChange", content.analysis);
              analysisContentRef.current = content.analysis;
              setCurrentStep(2);
            }}
            onBookContentChange={(content) => {
              Logger.log("onBookContentChange", content.substring(0, 100));
              bookContentRef.current = content;
              setCurrentStep(2);
            }}
            onUrlContentChange={(content) => {
              Logger.log(
                "Parent: URL content received",
                content.substring(0, 300),
              );
              urlContentRef.current = content;
              setCurrentStep(2);
            }}
            onPredefinedThemeChange={(e) => setPredefinedTheme(e.target.value)}
            onYoutubeTranscriptChange={(transcriptContent) => {
              Logger.log(
                "onYoutubeTranscriptChange körs med: ",
                transcriptContent,
              );
              transcriptRef.current = transcriptContent;
              setCurrentStep(2);
            }}
            onFileUpload={(content) => {
              Logger.log("onFileUpload körs med: ", content);
              uploadedFileRef.current = content;
              setCurrentStep(2);
            }}
            onWikipediaContentChange={(content) => {
              Logger.log(
                "Parent: Wikipedia content received",
                content.substring(0, 100),
              );
              wikipediaContentRef.current = content;
              setCurrentStep(2);
            }}
            onRandomizedContentChange={(content) => {
              Logger.log("randomizedContentRef", content.substring(0, 100));
              randomizedContentRef.current = content;
              setCurrentStep(2);
            }}
            onCoursePlanContentChange={(content) => {
              Logger.log("onCoursePlanChange", content.substring(0, 100));
              coursePlanContentRef.current = content;
              setCurrentStep(2);
            }}
            lessonType={"Podcast.js"}
            user={user}
            theme={theme}
            styles={styles}
            forPodcast={true}
          />
        )}
        {/*
        {currentStep === 2 && (
          <>
            <BackButton
              currentStep={currentStep}
              onClick={() => {
                setCurrentStep(currentStep - 1);

                resetThemeContent();
              }}
              show={currentStep !== 1}
            />
            <AnimatedStep isRevealed={true}>
              <Box sx={{ ...styles.headlineLessonBox, mt: 8 }}>
                <Typography variant="h6" sx={styles.headlineLessonBoxTitle}>
                  <span>2</span> Välj typ av podcast
                </Typography>
              </Box>
              <Box
                sx={{
                  ...styles.freshBox,
                  padding: "40px",
                }}
              >
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth variant="outlined">
                    <Typography
                      variant="formLabelSinUnderline"
                      sx={{ fontWeight: "500", mb: 1 }}
                    >
                      Välj typ av podcast
                    </Typography>
                    <Select
                      value={podcastType}
                      onChange={(e) => setPodcastType(e.target.value)}
                      disabled={loading}
                    >
                      <MenuItem value="Standard">Standard</MenuItem>
                      <MenuItem value="Argumentation/Debatt">
                        Argumentation/Debatt
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Box>
            </AnimatedStep>
          </>
        )}
*/}
        {currentStep === 2 && (
          <>
            <BackButton
              currentStep={currentStep}
              onClick={() => {
                setCurrentStep(currentStep - 1);
                setSpeaker1("");
                setSpeaker2("");
              }}
              show={currentStep !== 1}
            />
            <AnimatedStep isRevealed={true}>
              <Box sx={{ ...styles.headlineLessonBox, mt: 6 }}>
                <Typography variant="h6" sx={styles.headlineLessonBoxTitle}>
                  <span>2</span> Välj deltagare
                </Typography>
              </Box>
              <Box
                sx={{
                  ...styles.freshBox,
                  ...styles.softBoxShadow,
                  padding: "40px",
                  width: { xs: "100%", md: "60%" },
                  margin: "0 auto",
                }}
              >
                <Typography
                  variant="body1"
                  paragraph
                  sx={{ textAlign: "center", mb: 4, color: "text.secondary" }}
                >
                  Välj två deltagare som ska tala i din podcast
                </Typography>

                <Grid container spacing={4}>
                  <Grid item xs={12} md={12}>
                    <Paper
                      elevation={3}
                      onClick={() => {
                        setCurrentSpeakerSelection(1);
                        setOpenSpeakerDialog(true);
                      }}
                      sx={{
                        ...styles.freshBox,
                        boxShadow: "none",

                        p: 3,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center", // This keeps things vertically centered
                        height: "100%",
                        cursor: "pointer",
                        textAlign: { xs: "center", md: "left" },
                        transition: "all 0.2s",
                        background:
                          theme.palette.mode === "dark"
                            ? "rgb(40 57 71)"
                            : "rgb(225 225 225 / 19%)",
                        "&:hover": {
                          transform: "translateY(-3px)",
                          border: `1px solid ${theme.palette.primary.main}`,
                        },
                      }}
                    >
                      {/* Avatar first (on the left) */}
                      <Box
                        sx={{ mr: { xs: 0, md: 3 }, mb: { xs: 3, md: "0" } }}
                      >
                        {speaker1 ? (
                          <Avatar
                            src={
                              availableSpeakers.find((s) => s.id === speaker1)
                                ?.avatar || ""
                            }
                            alt={speaker1}
                            sx={{ width: 80, height: 80 }}
                          />
                        ) : (
                          <Avatar
                            sx={{
                              width: 80,
                              height: 80,
                              backgroundColor: isDark ? "#212c36" : "white",
                            }}
                          >
                            <PersonOutlineIcon
                              sx={{ fontSize: 40, color: "text.secondary" }}
                            />
                          </Avatar>
                        )}
                      </Box>

                      {/* Text content next to avatar */}
                      <Box>
                        <Typography
                          variant="h6"
                          gutterBottom
                          sx={{ fontWeight: 600 }}
                        >
                          Välj talare 1
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ color: "text.secondary" }}
                        >
                          Klicka för att välja talare 1
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Paper
                      elevation={3}
                      onClick={() => {
                        setCurrentSpeakerSelection(2);
                        setOpenSpeakerDialog(true);
                      }}
                      sx={{
                        ...styles.freshBox,

                        boxShadow: "none",
                        p: 3,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center", // This keeps things vertically centered
                        textAlign: { xs: "center", md: "left" },
                        height: "100%",
                        transition: "all 0.2s",
                        cursor: "pointer",
                        background:
                          theme.palette.mode === "dark"
                            ? "rgb(40 57 71)"
                            : "rgb(225 225 225 / 19%)",
                        "&:hover": {
                          transform: "translateY(-3px)",
                          border: `1px solid ${theme.palette.primary.main}`,
                        },
                      }}
                    >
                      {/* Avatar first (on the left) */}
                      <Box
                        sx={{ mr: { xs: 0, md: 3 }, mb: { xs: 3, md: "0" } }}
                      >
                        {speaker2 ? (
                          <Avatar
                            src={
                              availableSpeakers.find((s) => s.id === speaker2)
                                ?.avatar || ""
                            }
                            alt={speaker2}
                            sx={{ width: 80, height: 80 }}
                          />
                        ) : (
                          <Avatar
                            sx={{
                              width: 80,
                              height: 80,
                              backgroundColor: isDark ? "#212c36" : "white",
                            }}
                          >
                            <PersonOutlineIcon
                              sx={{ fontSize: 40, color: "text.secondary" }}
                            />
                          </Avatar>
                        )}
                      </Box>

                      {/* Text content next to avatar */}
                      <Box>
                        <Typography
                          variant="h6"
                          gutterBottom
                          sx={{ fontWeight: 600 }}
                        >
                          Välj talare 2
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ color: "text.secondary" }}
                        >
                          Klicka för att välja talare 2
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </AnimatedStep>

            <SpeakerSelectionDialog />
          </>
        )}

        {currentStep === 3 && (
          <>
            <BackButton
              currentStep={currentStep}
              onClick={() => {
                setCurrentStep(1);
                setPodcastType("");
                setRolePerson1("Programledare");
                setRolePerson2("Gäst");
                setUserInstructions("");
                setShowMoreOptions(false);

                setSpeaker1("");
                setSpeaker2("");
                setCreativity(0.5);
                resetThemeContent();
              }}
              show={currentStep !== 1}
            />
            <AnimatedStep isRevealed={true}>
              <Box sx={{ ...styles.headlineLessonBox, mt: 8 }}>
                <Typography variant="h6" sx={styles.headlineLessonBoxTitle}>
                  <span>3</span> Generera podcasten
                </Typography>
              </Box>
              <Box
                sx={{
                  ...styles.freshBox,
                  ...styles.softBoxShadow,
                  padding: "40px",
                  width: { xs: "100%", md: "65%" },
                  margin: "0 auto",
                }}
              >
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sx={{ display: "none" }}>
                      <FormControl component="fieldset">
                        <Typography variant="body2">
                          <Box
                            component="span"
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <Checkbox
                              checked={isLongForm}
                              onChange={(e) => setIsLongForm(e.target.checked)}
                              disabled={loading}
                              id="longform"
                              color="primary"
                            />
                            Generera långform podcast (20-30 minuter)
                          </Box>
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} sx={{ display: "none" }}>
                      <Typography
                        variant="formLabelSinUnderline"
                        sx={{
                          fontWeight: "500",
                          display: "block",
                          mb: 1,
                        }}
                      >
                        Namn
                      </Typography>

                      <TextField
                        id="podcastName"
                        fullWidth
                        value={podcastName}
                        onChange={(e) => setPodcastName(e.target.value)}
                        placeholder="Ange ett namn för din podcast"
                        disabled={loading}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} sx={{ display: "none" }}>
                      <Typography
                        variant="formLabelSinUnderline"
                        sx={{
                          fontWeight: "500",
                          display: "block",
                          mb: 1,
                        }}
                      >
                        Slogan
                      </Typography>
                      <TextField
                        id="podcastTagline"
                        fullWidth
                        value={podcastTagline}
                        onChange={(e) => setPodcastTagline(e.target.value)}
                        placeholder="Ange en slogan för din podcast"
                        disabled={loading}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography
                        variant="formLabelSinUnderline"
                        sx={{
                          fontWeight: "500",
                          display: "block",
                        }}
                      >
                        Namn på din podcast
                      </Typography>
                      <TextField
                        placeholder="Namn"
                        value={podcastNameOwn}
                        onChange={(e) => setPodcastNameOwn(e.target.value)}
                        autoFocus
                        variant="outlined"
                        sx={{
                          mt: 1,
                          width: "100%",
                          mb: { xs: 0, md: 4 },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography
                        variant="formLabelSinUnderline"
                        sx={{
                          fontWeight: "500",
                          display: "block",
                          mb: 1,
                        }}
                      >
                        Språk
                      </Typography>

                      <Box sx={{ mt: 1 }}>
                        <LanguageSelector
                          language={outputLanguage}
                          setLanguage={setOutputLanguage}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Collapse in={showMoreOptions}>
                    <Box sx={{ mt: 3, mb: 3 }}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth variant="outlined">
                            <Typography
                              variant="formLabelSinUnderline"
                              sx={{
                                fontWeight: "500",
                                display: "block",
                                mb: 1,
                              }}
                            >
                              Konversationsstil
                            </Typography>
                            <Select
                              id="conversationStyle"
                              multiple
                              value={conversationStyle}
                              onChange={(e) =>
                                setConversationStyle(e.target.value)
                              }
                              disabled={loading}
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {styleOptions.map((style) => (
                                <MenuItem key={style} value={style}>
                                  <Checkbox
                                    checked={conversationStyle.includes(style)}
                                  />
                                  <Typography variant="body2">
                                    {style}
                                  </Typography>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth variant="outlined">
                            <Typography
                              variant="formLabelSinUnderline"
                              sx={{
                                fontWeight: "500",
                                display: "block",
                                mb: 1,
                              }}
                            >
                              Dialogstruktur
                            </Typography>
                            <Select
                              id="dialogueStructure"
                              multiple
                              value={dialogueStructure}
                              onChange={(e) =>
                                setDialogueStructure(e.target.value)
                              }
                              disabled={loading}
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {structureOptions.map((structure) => (
                                <MenuItem key={structure} value={structure}>
                                  <Checkbox
                                    checked={dialogueStructure.includes(
                                      structure,
                                    )}
                                  />
                                  <Typography variant="body2">
                                    {structure}
                                  </Typography>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Typography
                            variant="formLabelSinUnderline"
                            sx={{
                              fontWeight: "500",
                              display: "block",
                              mb: 1,
                            }}
                          >
                            Roll för person 1
                          </Typography>
                          <TextField
                            id="rolePerson1"
                            fullWidth
                            value={rolePerson1}
                            onChange={(e) => setRolePerson1(e.target.value)}
                            placeholder="T.ex. expert eller programledare"
                            disabled={loading}
                            variant="outlined"
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Typography
                            variant="formLabelSinUnderline"
                            sx={{
                              fontWeight: "500",
                              display: "block",
                              mb: 1,
                            }}
                          >
                            Roll för person 2
                          </Typography>
                          <TextField
                            id="rolePerson2"
                            fullWidth
                            value={rolePerson2}
                            onChange={(e) => setRolePerson2(e.target.value)}
                            placeholder="T.ex. expert eller gäst"
                            disabled={loading}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth variant="outlined">
                            <Typography
                              variant="formLabelSinUnderline"
                              sx={{
                                fontWeight: "500",
                                display: "block",
                                mb: 1,
                              }}
                            >
                              Engagemangstekniker
                            </Typography>
                            <Select
                              id="engagementTechniques"
                              multiple
                              value={engagementTechniques}
                              onChange={(e) =>
                                setEngagementTechniques(e.target.value)
                              }
                              disabled={loading}
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {engagementOptions.map((technique) => (
                                <MenuItem key={technique} value={technique}>
                                  {technique}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography
                            variant="formLabelSinUnderline"
                            sx={{
                              fontWeight: "500",
                              display: "block",
                              mb: 1,
                            }}
                          >
                            Kreativitetsnivå: {creativity}
                          </Typography>
                          <Slider
                            id="creativity"
                            min={0}
                            max={1}
                            step={0.1}
                            value={creativity}
                            onChange={(e, newValue) => setCreativity(newValue)}
                            disabled={loading}
                            valueLabelDisplay="auto"
                            sx={{
                              height: 8, // This affects the overall component height
                              "& .MuiSlider-track": {
                                height: 15, // Height of the active track
                                border: "none",
                              },
                              "& .MuiSlider-rail": {
                                height: 15, // Height of the rail (background)
                                opacity: 0.5,
                              },
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <FormControl fullWidth variant="outlined">
                            <Typography
                              variant="formLabelSinUnderline"
                              sx={{
                                fontWeight: "500",
                                display: "block",
                                mb: 0,
                              }}
                            >
                              Röstmodell
                            </Typography>
                            <AIModelSelect
                              selectedModel={selectedModel}
                              setSelectedModel={setSelectedModel}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sx={{ display: "none" }}>
                        <Typography
                          variant="formLabelSinUnderline"
                          sx={{
                            fontWeight: "500",
                            display: "block",
                            mb: 1,
                            mt: 3,
                          }}
                        >
                          Ytterligare instruktioner
                        </Typography>
                        <TextField
                          id="userInstructions"
                          fullWidth
                          multiline
                          rows={3}
                          value={userInstructions}
                          onChange={(e) => setUserInstructions(e.target.value)}
                          placeholder="Specifika instruktioner eller teman du vill inkludera"
                          disabled={loading}
                          variant="outlined"
                        />
                      </Grid>
                    </Box>
                  </Collapse>
                  <Stack
                    direction={{ xs: "column", md: "column" }}
                    spacing={2}
                    alignItems="center"
                    sx={{ width: "100%", position: "relative", mt: 5 }}
                  >
                    <Button
                      type="submit"
                      variant="purp"
                      disabled={loading}
                      sx={{ mt: 2, py: 1.5 }}
                      startIcon={<GenerateIcon />}
                    >
                      {loading ? "Genererar..." : "Generera podcast"}
                    </Button>

                    <Button
                      variant="print"
                      disableRipple
                      startIcon={
                        showMoreOptions ? <ExpandLessIcon /> : <SettingsIcon />
                      }
                      onClick={() => setShowMoreOptions(!showMoreOptions)}
                      sx={{
                        position: { xs: "static", md: "absolute" },
                        right: { md: "0px" },
                        bottom: { md: "0px" },
                        width: { xs: "100%", md: "auto" },
                        paddingLeft: "20px",
                        paddingRight: "8px",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        textTransform: "none",
                      }}
                      fullWidth={true}
                    />
                  </Stack>

                  {error && (
                    <Box
                      sx={{ mt: 2, p: 2, bgcolor: "#ffebee", borderRadius: 1 }}
                    >
                      <Typography color="error">{error}</Typography>
                    </Box>
                  )}

                  {success && (
                    <Box
                      sx={{ mt: 2, p: 2, bgcolor: "#e8f5e9", borderRadius: 1 }}
                    >
                      <Typography color="success.main">{success}</Typography>
                    </Box>
                  )}

                  {audioUrl && (
                    <Box
                      sx={{
                        mt: 4,
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        Din Podcast
                      </Typography>
                      <Box
                        component="audio"
                        controls
                        src={audioUrl}
                        sx={{ width: "100%", mb: 2 }}
                      />
                      <Button
                        variant="outlined"
                        color="primary"
                        component="a"
                        href={audioUrl}
                        download
                        startIcon={<DescriptionIcon />}
                      >
                        Ladda ner Podcast
                      </Button>
                    </Box>
                  )}
                </form>
              </Box>
            </AnimatedStep>
          </>
        )}
      </Box>
      <ImageLoadingDialog
        open={loading}
        message="Genererar din podcast. Vänta 1-2 minuter..."
        podcast="true"
        user={user}
      />
      <Menu
        anchorEl={languageMenuAnchorEl}
        open={Boolean(languageMenuAnchorEl)}
        onClose={() => setLanguageMenuAnchorEl(null)}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            ...styles.roundMenu,
            ...styles.roundMenuLarger,
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setLanguageMenuAnchorEl(null);
            navigate("/app/podcast/6GKhkJl3EqvqfgC4Vr90");
          }}
          sx={{
            ...styles.menuItemStyle,
            ...styles.menuItemStyleLarger,
          }}
        >
          <ListItemIcon sx={{ mr: 1 }}>
            <img
              src="/img/svenska.png"
              alt="Swedish"
              style={{ width: "24px", height: "24px" }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Svenska"
            secondary="Lyssna på podcasten på svenska"
          />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setLanguageMenuAnchorEl(null);
            navigate("/app/podcast/GGa7P52ZqeFHljiBaA6R"); // Replace with your Arabic version ID
          }}
          sx={{
            ...styles.menuItemStyle,
            ...styles.menuItemStyleLarger,
          }}
        >
          <ListItemIcon sx={{ mr: 1 }}>
            <img
              src="/img/arabiska.png"
              alt="Arabic"
              style={{ width: "24px", height: "24px" }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Arabiska"
            secondary="Lyssna på podcasten på arabiska"
          />
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default PodcastGenerator;
